export const TRAVELER_DOC = {
  PASSPORT_FRONT: "passport_front",
  PASSPORT_BACK: "passport_back",
  AADHAR_FRONT: "aadhar_card_front",
  AADHAR_BACK: "aadhar_card_back",
  FLIGHT_TICKET: "flight_ticket",
  RESIDENCE_PROOF: "residence_proof",
};

export const ISSUE_AS = [
  { label: "User", value: "agent" },
  { label: "Operator", value: "operator" },
];

export const NOMINEE_RELATION_OPTIONS = [
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Spouse",
  "Son",
  "Daughter",
];

export const COVER_TYPES = {
  MASTER_COVER: "master-covers",
  CUSTOMIZE_COVER: "customize-covers",
};

const NAME_PATTERN = /^[\p{L}\s\-'.]+$/u;

export const normalizeName = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, " ");

export const validateName = (value, { required = true, label = "Name" } = {}) => {
  const name = normalizeName(value);
  if (!name) return required ? `${label} is required` : true;
  if (name.length < 2 || name.length > 50)
    return `${label} must be 2–50 characters`;
  if (!NAME_PATTERN.test(name))
    return `${label} may only contain letters, spaces, hyphens, apostrophes, and periods`;
  return true;
};

export const validatePhone = (
  value,
  { required = true, label = "Phone number" } = {}
) => {
  const raw = String(value ?? "").trim();
  if (!raw) return required ? `${label} is required` : true;
  const digits = raw.startsWith("+") ? raw.slice(1).replace(/\D/g, "") : raw.replace(/\D/g, "");
  if (raw.startsWith("+") && raw.slice(1).replace(/\d/g, "") !== "")
    return `${label} may only contain digits after +`;
  if (digits.length < 7 || digits.length > 15)
    return `${label} must be 7–15 digits`;
  return true;
};

export const validateAadhaar = (value, { required = false } = {}) => {
  const digits = String(value ?? "").replace(/\s/g, "");
  if (!digits) return required ? "Aadhar number is required" : true;
  if (!/^\d{12}$/.test(digits))
    return "Aadhar number must be exactly 12 digits";
  if (!/^[2-9]/.test(digits))
    return "Aadhar number must start with 2–9";
  return true;
};
